/*
 * @Description: 岗位说明书管理
 * @Author: 杨志航
 * @Date: 2026-02-11 10:25:51
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Drawer,
  Input,
  Button,
  Select,
  Alert,
} from 'antd'
import { allTrim, filterParams, uniqueByName } from '@/utils'
import EditJobPostFile from './EditJobPostFile'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const JobPostFile = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [groupList, setGroupList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [departmentTypeList, setDepartmentTypeList] = useState([])
  const [jobPostList, setJobPostList] = useState([])
  const [jobPostFileList, setJobPostFileList] = useState([])

  useEffect(() => {
    getSearchData()
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getJobPostList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    setDepartmentList([])
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    currentPage = 1
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 编辑
  const handleEdit = data => {
    setEditData(data)
    setEditVisible(true)
  }

  const getSearchData = () => {
    Promise.all([
      api.getSelectGroupList({ limit: global.paramsLimit }),
      api.getCommon({ type: 'department_type' }),
      api.getJobPostList({ limit: global.paramsLimit }),
      api.getJobPostFileList({ limit: global.paramsLimit }),
    ]).then(list => {
      setGroupList(list[0].list)
      setDepartmentTypeList(list[1])
      setJobPostList(uniqueByName(list[2].list))
      setJobPostFileList(list[3].list)
    })
  }

  const getDepartMentList = (groupId, departmentName) => {
    api.getStaffJobPostDepartmentList({ 
      groupId 
    }).then(res => {
      setDepartmentList(res)
      setFieldsValue({
        departmentName,
      })
    }).catch(err => console.log(err))
  }

  const onSelectGroup = groupId => {
    if (groupId) {
      getDepartMentList(groupId, undefined)
    } else {
      setDepartmentList([])
      setFieldsValue({
        departmentName: undefined,
      })
    }
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <div className="form-box">
          <FormItem label="所属事业群">
            {getFieldDecorator('groupId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
              onChange={onSelectGroup}
            >
              {
                groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="所属部门">
            {getFieldDecorator('departmentName')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                departmentList.map((item, index) => <Option key={index} value={item}>{item}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="部门类型">
            {getFieldDecorator('departmentType')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                departmentTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="岗位名称">
            {getFieldDecorator('jobPostName')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                jobPostList.map((item, index) => <Option key={index} value={item.name}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="岗位说明书">
            {getFieldDecorator('jobPostFileId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                jobPostFileList.map((item, index) => <Option key={index} value={item.id}>{item.fileName}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="在职人数" style={{ marginBottom: 0 }}>
            <FormItem style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
              {getFieldDecorator('onJobNumStart')(
                <Input placeholder="请输入" allowClear />
              )}
            </FormItem>
            <span style={{ display: 'inline-block', width: '24px', textAlign: 'center', float: 'left' }}>~</span>
            <FormItem style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
              {getFieldDecorator('onJobNumEnd')(
                <Input placeholder="请输入" allowClear />
              )}
            </FormItem>
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={() => history.push('/hr/jobpostfile/relation')}>岗位说明书关联</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
      >
        <Column title="事业群名称" dataIndex="groupName" />
        <Column title="部门名称" dataIndex="departmentName" />
        <Column title="部门类型" dataIndex="departmentTypeCn" />
        <Column title="岗位名称" dataIndex="name" />     
        <Column title="在职人数" dataIndex="onJobNum" />
        <Column 
          title="岗位说明书" 
          dataIndex="fileName"
          render={(text, record) => <a href={record.fileInfo.url} target='_blank'>{text}</a>} 
        />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={80}
          render={(text, record) => <a onClick={() => handleEdit(record)}>编辑</a>}
        />
      </Table>
    </div>
    <Drawer
      title="编辑"
      width={600}
      onClose={() => setEditVisible(false)}
      visible={editVisible}
      destroyOnClose={true}
    >
      <EditJobPostFile 
        setEditVisible={setEditVisible}
        getList={getList}
        editData={editData}
      />
    </Drawer>
  </>
}

export default Form.create()(JobPostFile)
